import { apiSlice } from '../apiSlice';
import { DeleteResponse } from '../schemas/apiResponse';
import { User } from '../schemas/user';
import { providesList } from '../utils/providesList';

const USERS_PATH = '/users';

const userEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserMe: builder.query<User, void>({
      query: () => `${USERS_PATH}/me`,
      providesTags: (result) => [{ type: 'User', id: result?.id }],
    }),
    getUsers: builder.query<User[], void>({
      query: () => USERS_PATH,
      transformResponse: (res: User[]) =>
        res.sort((a, b) => a.firstName.localeCompare(b.firstName)),
      providesTags: (result) => providesList(result, 'User'),
    }),
    getUser: builder.query<User, string>({
      query: (id) => `${USERS_PATH}/${id}`,
      providesTags: (result, error, id) => [{ type: 'User', id }],
    }),
    addUser: builder.mutation<User, Partial<User>>({
      query: (body) => ({
        url: USERS_PATH,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'User', id: 'LIST' }],
    }),
    updateUser: builder.mutation<User, Partial<User>>({
      query: (user) => ({
        url: `${USERS_PATH}/${user.id}`,
        method: 'PATCH',
        body: user,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'User', id }],
    }),
    deleteUser: builder.mutation<DeleteResponse, string>({
      query(id) {
        return {
          url: `${USERS_PATH}/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, id) => [{ type: 'User', id }],
    }),
  }),
});

export const {
  useGetUserMeQuery,
  useGetUsersQuery,
  useGetUserQuery,
  useAddUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = userEndpoints;
